<template>
  <SvoiBreadcrumbs :items="items" :component-type="resolvedComponentType" />
</template>

<script lang="ts" setup>
  import { SvoiBreadcrumbs } from '@svoi-ui/components/breadcrumbs'
  import { LinkTypesEnum } from '@svoi-ui/interfaces/link-type'
  import type { BreadcrumbItem } from '@svoi-ui/interfaces/breadcrumbs'
  import { useAppZones } from '~/composables/use-app-zones'

  const props = defineProps<{
    items: Array<BreadcrumbItem>
    componentType?: string
  }>()

  const { isOwnRoute } = useAppZones()

  /**
   * SvoiBreadcrumbs задаёт тип ссылки сразу всем крошкам,
   * поэтому одна чужая крошка переводит весь ряд на <a href>.
   * @see ~/composables/use-app-zones.ts - реестр зон и isOwnRoute
   */
  const resolvedComponentType = computed(() => {
    if (props.componentType) return props.componentType

    const hasForeignLink = props.items.some(item => item.link && !isOwnRoute(item.link))
    return hasForeignLink ? LinkTypesEnum.a : LinkTypesEnum.nuxtLink
  })
</script>

<style lang="scss" scoped>
  .svoi-breadcrumbs {
    row-gap: 4px;
  }
</style>
